export default "__VITE_ASSET__BeN7wGBq__"